import React, { Component } from 'react'
import CommonTableModule from '../../CommonTable/CommonTableModule';
import { Card, Alert, Spinner, Badge, Button } from "react-bootstrap";
import axios from "axios";
import CommonLoader from '../../loaderComponent/CommonLoader';
import { FaCheckCircle, FaHourglassHalf, FaTimesCircle } from 'react-icons/fa';
import { hasPermission } from '../../../utils/usePermission';

export default class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryData: [],
      loading: true,
      hasError: false,
      errMsg: ""
    };
  }


  async componentDidMount() {
    this.setState({ loading: true })
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/expenseCategory/list', { headers });
      this.setState({ categoryData: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 500);
    } catch (error) {
      console.error("Error fetching category:", error);
      let errorMessage = "Failed to load category.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }


  handleAddExpense = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push('/add-expense-category')
      this.setState({ loading: false });
    }, 500);

  }

  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
      {
        key: "status",
        label: "Status",
        render: (value) => {
          const isActive = value.toLowerCase() === "active";

          const styles = {
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 12px",
            borderRadius: "20px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            backgroundColor: isActive ? "#E6F4EA" : "#FBEAEA",
            color: isActive ? "#216e39" : "#A94442",
            border: `1px solid ${isActive ? "#B6E2C5" : "#F1B5B5"}`,
            minWidth: "90px",
            textAlign: "center",
          };

          return (
            <span style={styles}>
              {isActive ? <FaCheckCircle /> : <FaTimesCircle />}
              {value}
            </span>
          );
        }
        // render: (value) => (
        //   <Badge variant={value === "Active" ? "success" : "danger"}>{value.toUpperCase()}</Badge>
        // ),
      },
    ];
    return (
      <div className="container-fluid pt-4" >
        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M1S2B1') && (
            <div className='add-role'>
              <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddExpense}> <i className="fa fa-plus-circle"></i> Add Expense Category</Button>
            </div>
          )}
          <Card className="mb-3">
            <Card.Header>
              <b>Category List</b>
            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.categoryData} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div>
    )
  }
}
